var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-schema-form', { ref: "form", staticClass: "nine-grid", attrs: { "config": _vm.formConfig, "schema": _vm.schema, "model": _vm.formModel } });
};
var staticRenderFns = [];

export { render, staticRenderFns };